import { useMutation } from "@tanstack/react-query";
import { Patient, PatientControllerApi } from "../services";
import { getConfigObject } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */

interface Params {
  patient: Patient;
  xTENANTID?: string;
}

export const useEditPatient = () =>
  useMutation({
    mutationKey: ["edit-patient"],
    mutationFn: async (params: Params) =>
      new PatientControllerApi(getConfigObject()).updatePatient(
        params.patient,
        params.xTENANTID
      ),
  });
